import axios from 'axios';
import config from '../common/config';

export default {
  // Get devices for a specific user
  getUserDevices(token, userId) {
    return axios.get(`${config.config.ROOT_URL}/user_devices/${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  },

  // Get suspicious users (Manager only)
  getSuspiciousUsers(token, minDevices = 4, daysBack = 7) {
    
    return axios.get(`${config.config.ROOT_URL}/suspicious_users`, {
      params: {
        min_devices: minDevices,
        days_back: daysBack
      },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then(response => {
      return response;
    }).catch(error => {
      console.error('API Error:', error);
      console.error('Error Response:', error.response);
      throw error;
    });
  },

  // Get device analysis for a user
  getDeviceAnalysis(token, userId, daysBack = 30) {
    return axios.get(`${config.config.ROOT_URL}/device_analysis/${userId}`, {
      params: {
        days_back: daysBack
      },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  }
}; 